import React from 'react';

export const VideoPlayBtn = (): JSX.Element => {
  return (
    <div>
      <div className="videoPlayBtn" data-testid="video-play-btn">
        <svg
          width="74"
          height="74"
          viewBox="0 0 96 96"
          fill="none"
          id="playBtn"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d)">
            <circle
              className="videoPlayBtnOuterCircle"
              cx="46"
              cy="46"
              r="37"
              fill="white"
              fillOpacity="0.7"
            ></circle>
            <circle
              className="videoPlayBtnOuterCircle"
              cx="46"
              cy="46"
              r="36"
              stroke="#1678FB"
              strokeWidth="2"
            ></circle>
          </g>
          <path
            className="videoPlayIcon"
            d="M63.3496 48.1872C64.5843 47.4012 64.5843 45.5988 63.3496 44.8128L39.824 29.8373C38.4926 28.9897 36.75 29.9461 36.75 31.5244V61.4756C36.75 63.0539 38.4926 64.0103 39.824 63.1627L63.3496 48.1872Z"
            fill="#1678FB"
          ></path>
          <defs>
            <filter
              id="filter0_d"
              x="0"
              y="0"
              width="96"
              height="96"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dx="2" dy="2"></feOffset>
              <feGaussianBlur stdDeviation="5.5"></feGaussianBlur>
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.46125 0 0 0 0 0.483182 0 0 0 0 0.5125 0 0 0 0.2 0"
              ></feColorMatrix>
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              ></feBlend>
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              ></feBlend>
            </filter>
          </defs>
        </svg>
      </div>
    </div>
  );
};
